export default {
  computed: {
    basicBinaryOptions() {
      return [{
        label: this.$t("application-form.yes"),
        value: true
      }, {
        label: this.$t("application-form.no"),
        value: false
      }];
    },
    salutationOptions() {
      return [{
        value: "mr.",
        label: this.$t("application-form.mr")
      }, {
        value: "mrs.",
        label: this.$t("application-form.mrs")
      }, {
        value: "ms.",
        label: this.$t("application-form.ms")
      }, {
        value: "dr.",
        label: this.$t("application-form.dr")
      }, {
        value: "rev.",
        label: this.$t("application-form.rev")
      }, {
        value: "miss",
        label: this.$t("application-form.miss")
      }, {
        value: "judge",
        label: this.$t("application-form.judge")
      }];
    },
    maritalStatusOptions() {
      return [{
        label: this.$t("application-form.single"),
        value: "single"
      }, {
        label: this.$t("application-form.married"),
        value: "married"
      }, {
        label: this.$t("application-form.common-law"),
        value: "common-law"
      }, {
        label: this.$t("application-form.separated"),
        value: "seperated"
      }, {
        label: this.$t("application-form.divorced"),
        value: "divorced"
      }, {
        label: this.$t("application-form.widowed"),
        value: "widowed"
      }, {
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    languagePreferenceOptions() {
      return [{
        label: this.$t("application-form.english"),
        value: "english"
      }, {
        label: this.$t("application-form.french"),
        value: "french"
      }];
    },
    ownOptions() {
      return [{
        action: "hide",
        label: this.$t("application-form.own-my-own-home"),
        value: "own"
      }, {
        action: "show",
        label: this.$t("application-form.currently-rent"),
        value: "rent"
      }, {
        action: "hide",
        label: this.$t("application-form.live-with-parents"),
        value: "live-with-parents"
      }, {
        action: "hide",
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    binaryTrueShowsOptions() {
      return [{
        label: this.$t("application-form.yes"),
        value: true,
        action: "show"
      }, {
        label: this.$t("application-form.no"),
        value: false,
        action: "hide"
      }];
    },
    binaryFalseShowsOptions() {
      return [{
        label: this.$t("application-form.yes"),
        value: true,
        action: "hide"
      }, {
        label: this.$t("application-form.no"),
        value: false,
        action: "show"
      }];
    },
    identificationTypeOptions() {
      return [{
        label: this.$t("application-form.birth-cert"),
        value: "birth-cert"
      }, {
        label: this.$t("application-form.drivers-license"),
        value: "drivers-license"
      }, {
        label: this.$t("application-form.social-ins-card"),
        value: "social-ins-card"
      }, {
        label: this.$t("application-form.passport"),
        value: "passport"
      }, {
        label: this.$t("application-form.health-ins-card"),
        value: "health-ins-card"
      }, {
        label: this.$t("application-form.pr-card"),
        value: "pr-card"
      }, {
        label: this.$t("application-form.citizenship-cert"),
        value: "citizenship-cert"
      }, {
        label: this.$t("application-form.imm-1000-imm-form"),
        value: "imm-1000-imm-form"
      }, {
        label: this.$t("application-form.imm-1442-citizenship-and-imm-canada"),
        value: "imm-1442-citizenship-and-imm-canada"
      }, {
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    operatingAsOptions() {
      return [{
        label: this.$t("application-form.sole-proprietorship"),
        value: "sole-proprietorship"
      }, {
        label: this.$t("application-form.partnership"),
        value: "partnership"
      }, {
        label: this.$t("application-form.corporation"),
        value: "corporation"
      }];
    },
    employmentTypeOptions() {
      return [{
        label: this.$t("application-form.full-time"),
        value: "full-time"
      }, {
        label: this.$t("application-form.part-time"),
        value: "part-time"
      }, {
        label: this.$t("application-form.seasonal"),
        value: "seasonal"
      }];
    },
    occupationOptions() {
      return [{
        label: this.$t("application-form.self-employed"),
        value: "self-employed"
      }, {
        label: this.$t("application-form.management"),
        value: "management"
      }, {
        label: this.$t("application-form.clerical"),
        value: "clerical"
      }, {
        label: this.$t("application-form.labour-tradesperson"),
        value: "labour-tradesperson"
      }, {
        label: this.$t("application-form.retired"),
        value: "retired"
      }, {
        label: this.$t("application-form.professional"),
        value: "professional"
      }, {
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    incomeTypeOptions() {
      return [{
        label: this.$t("application-form.salary"),
        value: "salary"
      }, {
        label: this.$t("application-form.hourly"),
        value: "hourly"
      }, {
        label: this.$t("application-form.hourly-and-commissions"),
        value: "hourly-and-commissions"
      }, {
        label: this.$t("application-form.commissions"),
        value: "commissions"
      }, {
        label: this.$t("application-form.self-employed"),
        value: "self-employed"
      }, {
        label: this.$t("application-form.other-employment-income"),
        value: "other-employment-income"
      }];
    },
    industrySectorOptions() {
      return [{
        label: this.$t("application-form.construction"),
        value: "construction"
      }, {
        label: this.$t("application-form.government"),
        value: "government"
      }, {
        label: this.$t("application-form.health"),
        value: "health"
      }, {
        label: this.$t("application-form.education"),
        value: "education"
      }, {
        label: this.$t("application-form.high-tech"),
        value: "high-tech"
      }, {
        label: this.$t("application-form.retail-sales"),
        value: "retail-sales"
      }, {
        label: this.$t("application-form.leisure-entertainment"),
        value: "leisure-entertainment"
      }, {
        label: this.$t("application-form.banking-finance"),
        value: "banking-finance"
      }, {
        label: this.$t("application-form.transportation"),
        value: "transportation"
      }, {
        label: this.$t("application-form.services"),
        value: "services"
      }, {
        label: this.$t("application-form.manufacturing"),
        value: "manufacturing"
      }, {
        label: this.$t("application-form.farming-natural-resources"),
        value: "farming-natural-resources"
      }, {
        label: this.$t("application-form.varies"),
        value: "varies"
      }, {
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    incomePeriodOptions() {
      return [{
        label: this.$t("application-form.annual"),
        value: "annual"
      }, {
        label: this.$t("application-form.semi-annual"),
        value: "semi-annual"
      }, {
        label: this.$t("application-form.quarterly"),
        value: "quarterly"
      }, {
        label: this.$t("application-form.monthly"),
        value: "monthly"
      }, {
        label: this.$t("application-form.semi-monthly"),
        value: "semi-monthly"
      }, {
        label: this.$t("application-form.bi-weekly"),
        value: "bi-weekly"
      }, {
        label: this.$t("application-form.weekly"),
        value: "weekly"
      }];
    },
    additionalIncomeTypeOptions() {
      return [{
        label: this.$t("application-form.child-support"),
        value: "child-support"
      }, {
        label: this.$t("application-form.pension"),
        value: "pension"
      }, {
        label: this.$t("application-form.interest-income"),
        value: "interest-income"
      }, {
        label: this.$t("application-form.alimony"),
        value: "alimony"
      }, {
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    assetTypeOptions() {
      return [{
        label: this.$t("application-form.savings"),
        value: "savings"
      }, {
        label: this.$t("application-form.rrsp"),
        value: "rrsp"
      }, {
        label: this.$t("application-form.gift"),
        value: "gift"
      }, {
        label: this.$t("application-form.vehicle"),
        value: "vehicle"
      }, {
        label: this.$t("application-form.stocks-bonds-mutual"),
        value: "stocks-bonds-mutual"
      }, {
        label: this.$t("application-form.household-goods"),
        value: "household-goods"
      }, {
        label: this.$t("application-form.life-insurance"),
        value: "life-insurance"
      }, {
        label: this.$t("application-form.deposit-on-purchase"),
        value: "deposit-on-purchase"
      }, {
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    liabilityTypeOptions() {
      return [{
        action: "hide",
        label: this.$t("application-form.mortgage"),
        value: "mortgage"
      }, {
        action: "show",
        label: this.$t("application-form.credit-card"),
        value: "credit-card"
      }, {
        action: "hide",
        label: this.$t("application-form.personal-loan"),
        value: "personal-loan"
      }, {
        action: "hide",
        label: this.$t("application-form.auto-loan"),
        value: "auto-loan"
      }, {
        action: "hide",
        label: this.$t("application-form.alimony"),
        value: "alimony"
      }, {
        action: "hide",
        label: this.$t("application-form.child-support"),
        value: "child-support"
      }, {
        action: "hide",
        label: this.$t("application-form.student-loan"),
        value: "student-loan"
      }, {
        action: "hide",
        label: this.$t("application-form.wage-garnishment"),
        value: "wage-garnishment"
      }, {
        action: "show",
        label: this.$t("application-form.unsecured-line-of-credit"),
        value: "unsecured-line-of-credit"
      }, {
        action: "show",
        label: this.$t("application-form.secured-line-of-credit"),
        value: "secured-line-of-credit"
      }, {
        action: "hide",
        label: this.$t("application-form.income-tax"),
        value: "income-tax"
      }, {
        action: "hide",
        label: this.$t("application-form.mortgage-rental-property"),
        value: "mortgage-rental-property"
      }, {
        action: "hide",
        label: this.$t("application-form.lease"),
        value: "lease"
      }, {
        action: "hide",
        label: this.$t("application-form.auto-lease"),
        value: "auto-lease"
      }, {
        action: "hide",
        label: this.$t("application-form.rent"),
        disabled: true,
        value: "rent"
      }, {
        action: "hide",
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    liabilityPayoffOptions() {
      return [{
        label: this.$t("application-form.prior-to-advance"),
        value: "prior-to-advance"
      }, {
        label: this.$t("application-form.from-proceeds"),
        value: "from-proceeds"
      }, {
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    coapplicantTypeOptions() {
      return [{
        label: this.$t("application-form.applicant"),
        value: "applicant"
      }, {
        label: this.$t("application-form.co-signer"),
        value: "co-signer"
      }, {
        label: this.$t("application-form.guarantor"),
        value: "guarantor"
      }];
    },
    coApplicantRelationOptions() {
      return [{
        label: this.$t("application-form.spouse"),
        value: "spouse"
      }, {
        label: this.$t("application-form.common-law"),
        value: "common-law"
      }, {
        label: this.$t("application-form.related-family-member"),
        value: "related-family-member"
      }, {
        label: this.$t("application-form.parent"),
        value: "parent"
      }, {
        label: this.$t("application-form.sibling"),
        value: "sibling"
      }, {
        label: this.$t("application-form.child"),
        value: "child"
      }, {
        label: this.$t("application-form.grandchild"),
        value: "grandchild"
      }, {
        label: this.$t("application-form.grandparent"),
        value: "grandparent"
      }, {
        label: this.$t("application-form.other"),
        value: "other"
      }];
    }
  }
};